import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';
import { requireAuth, setDayjsTimezone } from '@/common/router/navigationGuard';
import { RouteRecordRaw } from 'vue-router';

const homeMenu: RouteRecordRaw[] = [
  {
    path: '/home',
    name: 'home',
    beforeEnter: [requireAuth, setDayjsTimezone],
    component: BaseViewport,
    meta: {
      viewport: VIEWPORT_TYPE.REALTIME,
    },
    children: [
      {
        name: 'HomeView',
        path: '',
        component: () => import('@/home/views/HomeView.vue'),
      },
    ],
  },
];

export { homeMenu };
